module.exports = __webpack_public_path__ + "img/Modern Maple.76237349.jpg";